import { render, staticRenderFns } from "./main-menu.vue?vue&type=template&id=1083a178&scoped=true"
import script from "./main-menu.vue?vue&type=script&lang=js"
export * from "./main-menu.vue?vue&type=script&lang=js"
import style0 from "./main-menu.vue?vue&type=style&index=0&id=1083a178&prod&lang=css"
import style1 from "./main-menu.vue?vue&type=style&index=1&id=1083a178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1083a178",
  null
  
)

export default component.exports